import React, { useContext, useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import { useToast } from '../../../controller/ToastController';
import CustomToggle from '../../../components/CustomToggle';
import DropdownSelect, { SelectType } from '../../../components/DropdownSelect';
import StoreController, {
  ConciergeType,
  CurrentStoreContext,
} from '../../../controller/StoreController';
import { useOutletContext } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { useConciergeState } from '../../../recoil/concierge';

const hourList: any = [];
const minuteList: any = [];
for (let i = 0; i < 24; i++) {
  hourList.push({
    key: i,
    value: i > 9 ? `${i}` : `0${i}`,
    label: i > 9 ? `${i}시` : `0${i}시`,
    name: i > 9 ? `${i}시` : `0${i}시`,
  });
}
for (let i = 0; i < 12; i++) {
  minuteList.push({
    key: i,
    value: i > 1 ? `${i * 5}` : `0${i * 5}`,
    label: i > 1 ? `${i * 5}분` : `0${i * 5}분`,
    name: i > 1 ? `${i * 5}분` : `0${i * 5}분`,
  });
}

const ConciergeSetting = () => {
  const showToast = useToast();

  const { currentStore } = useOutletContext<CurrentStoreContext>();

  const [useConcierge, setUseConcierge] = useRecoilState<boolean>(useConciergeState);
  const [conciergeItem, setConciergeItem] = useState<ConciergeType[]>([]);

  const [isTimeSet, setIsTimeSet] = useState<boolean>(false);
  const [startHour, setStartHour] = useState<SelectType>(hourList[0]);
  const [startMin, setStartMin] = useState<SelectType>(minuteList[0]);
  const [endHour, setEndHour] = useState<SelectType>(hourList[1]);
  const [endMin, setEndMin] = useState<SelectType>(minuteList[0]);

  // onChange
  const onChange_StartHour = (e: any) => {
    setStartHour(e);
  };
  const onChange_StartMin = (e: any) => {
    setStartMin(e);
  };
  const onChange_EndHour = (e: any) => {
    setEndHour(e);
  };
  const onChange_EndMin = (e: any) => {
    setEndMin(e);
  };

  // 필수 확인
  const checkRequired = () => {
    return true;
  };

  // const checkTime = () => {
  //   let enableAdd = true;
  //   if (
  //     startHour.value > endHour.value ||
  //     (startHour.value === endHour.value && startMin.value >= endMin.value)
  //   ) {
  //     enableAdd = false;
  //   }
  //   return enableAdd;
  // };

  const editConciergeItem = (index: number) => {
    const conciergeTemp = [...conciergeItem];
    conciergeTemp[index].use_yn = conciergeTemp[index].use_yn === 1 ? 0 : 1;
    setConciergeItem([...conciergeTemp]);
  };

  const getStartTime = (startTime: string) => {
    const startHour = startTime.slice(0, 2);
    const startMin = startTime.slice(3, 5);

    setStartHour({
      key: Number(startHour),
      value: startHour,
      name: `${startHour}시`,
      label: `${startHour}시`,
    });
    setStartMin({
      key: Number(startMin) / 5,
      value: startMin,
      name: `${startMin}분`,
      label: `${startMin}분`,
    });
  };

  const getEndTime = (endTime: string) => {
    const endHour = endTime.slice(0, 2);
    const endMin = endTime.slice(3, 5);

    setEndHour({
      key: Number(endHour),
      value: endHour,
      name: `${endHour}시`,
      label: `${endHour}시`,
    });
    setEndMin({
      key: Number(endMin) / 5,
      value: endMin,
      name: `${endMin}분`,
      label: `${endMin}분`,
    });
  };

  const getConciergeList = async () => {
    try {
      const oParams = {
        store_id: currentStore.value,
      };
      const oResponse = await StoreController.getConciergeList(oParams);
      if (oResponse && oResponse.data) {
        const oRes = oResponse.data;
        if (oRes && oRes.data) {
          setIsTimeSet(oRes.data.concierge_manage.is_concierge_time_set);
          if (oRes.data.concierge_manage.is_concierge_time_set) {
            getStartTime(oRes.data.concierge_manage.start_time);
            getEndTime(oRes.data.concierge_manage.end_time);
          }
          setUseConcierge(oRes.data.concierge_manage.status);
          setConciergeItem([...oRes.data.concierge_list]);
        }
      }
    } catch (e) {
      console.error('err => ', e);
    }
  };

  const setConciergeList = async () => {
    try {
      // if (checkTime()) {
      const oParams = {
        store_id: currentStore.value,
        concierge_manage: {
          is_concierge_time_set: isTimeSet,
          start_time: isTimeSet ? startHour.value + ':' + startMin.value : '00:00',
          end_time: isTimeSet ? endHour.value + ':' + endMin.value : '00:00',
          status: useConcierge,
        },
        concierge_list: conciergeItem,
      };
      const oResponse = await StoreController.setConciergeList(oParams);
      if (oResponse && oResponse.data) {
        const oRes = oResponse.data;
        if (oRes && oRes.data) {
          showToast('컨시어지 설정을 저장했어요');
        }
      }
      // } else {
      //   showToast('종료시간이 시작시간보다 빨라요', 'error');
      // }
    } catch (e) {
      console.error('err => ', e);
    }
  };

  useEffect(() => {
    getConciergeList();
  }, []);

  return (
    <>
      <Style>
        <div className="contentContainer">
          <div className="inputText">
            <div className="title initial">
              <h4>컨시어지 사용</h4>
              <CustomToggle
                toggleItem={useConcierge}
                onChange={() => setUseConcierge(!useConcierge)}
                activeColor="#4dd2ae"
              />
            </div>
          </div>
          <div className="inputText">
            <div className="title">
              <h5 className="greyFont">컨시어지 사용목록</h5>
            </div>
            <div className="buttonListWrap">
              {conciergeItem.map((item, index) => {
                return (
                  <button
                    key={index}
                    className={`itemButton ${item.use_yn === 1 && 'active'}`}
                    onClick={() => editConciergeItem(index)}>
                    <img src={item.file_url} alt={item.concierge_name} />
                    <p>{item.concierge_name}</p>
                  </button>
                );
              })}
            </div>
          </div>
        </div>
        <div className="contentContainer">
          <div className="inputText">
            <div className="title initial">
              <h4>사용시간 설정</h4>
            </div>
            <label>
              <input
                type="radio"
                id={`isTimeSet`}
                autoFocus={false}
                checked={!isTimeSet}
                onChange={() => setIsTimeSet(false)}
              />
              <div className="radio">{!isTimeSet ? <div className={`ball`} /> : <div />}</div>
              24시간
            </label>
            <label>
              <input
                type="radio"
                id={`not_isTimeSet`}
                autoFocus={false}
                checked={isTimeSet}
                onChange={() => setIsTimeSet(true)}
              />
              <div className="radio">{isTimeSet ? <div className={`ball`} /> : <div />}</div>
              사용시간 설정
            </label>
            <div className="selectWrap title">
              {/* <CustomToggle
                toggleItem={isAlways}
                onChange={() => setIsAlways(!isAlways)}
                activeColor="#4dd2ae"
              /> */}

              <div className="selectDateWrap">
                <h5 className="greyFont">시작시간</h5>
                <div className="selectWrap">
                  <div className="dateSelect">
                    <DropdownSelect
                      options={hourList}
                      defaultValue={startHour}
                      onChangeValue={onChange_StartHour}
                      disabled={!isTimeSet}
                    />
                  </div>
                  <div className="dateSelect">
                    <DropdownSelect
                      options={minuteList}
                      defaultValue={startMin}
                      onChangeValue={onChange_StartMin}
                      disabled={!isTimeSet}
                    />
                  </div>
                </div>
              </div>
              <div className="selectDateWrap">
                <h5 className="greyFont">종료시간</h5>
                <div className="selectWrap">
                  <div className="dateSelect">
                    <DropdownSelect
                      options={hourList}
                      defaultValue={endHour}
                      onChangeValue={onChange_EndHour}
                      disabled={!isTimeSet}
                    />
                  </div>
                  <div className="dateSelect">
                    <DropdownSelect
                      options={minuteList}
                      defaultValue={endMin}
                      onChangeValue={onChange_EndMin}
                      disabled={!isTimeSet}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button
            className={`submitButton ${!checkRequired() && 'inactive'}`}
            onClick={setConciergeList}>
            저장
          </button>
        </div>
      </Style>
    </>
  );
};

export default ConciergeSetting;

const Style = styled.div`
  .contentContainer:nth-child(1) {
    border-radius: 10px 10px 0 0;
  }
  .contentContainer:nth-child(2) {
    border-radius: 0 0 10px 10px;
  }

  .inputText {
    .title {
      padding: 30px 0 6px 0;
      display: flex;
      align-items: center;
      gap: 30px;

      h5 {
        color: #40977f;
        font-weight: 500;
      }
      .greyFont {
        font-size: 16px;
        color: #979797;
      }
      h4 {
        color: #555555;
      }
    }
    .title.initial {
      padding: 0 0 6px 0;
    }
  }
  .buttonListWrap {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    .itemButton {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      min-width: calc((100% - 48px) / 5);
      max-width: calc((100% - 48px) / 5);
      aspect-ratio: 1/1;
      border-radius: 5px;
      padding-top: 11px;
      padding-bottom: 9px;
      /* border: 1px solid #a7a7a7; */
      background: #898989;
      img {
        width: 64px;
        height: 56px;
        object-fit: contain;
      }
      p {
        font-size: 14px;
        font-weight: 400;
        color: #fff;
      }
    }
    .itemButton.active {
      /* padding-top: 6px;
      padding-bottom: 4px;
      border: 5px solid #4dd2ae; */
      /* background: #0000001a; */
      background: #4dd2ae;
    }
  }
  .selectWrap {
    flex: 1;
    display: flex;
    align-items: center;
    padding-top: 4px;
    gap: 10px;
    .selectDateWrap {
      flex: 1;
    }
  }
  .selectWrap.title {
    padding-top: 10px;
    gap: 10px;
  }
  .dateSelect {
    flex: 1;
  }
  input[type='radio'] {
    display: none;
  }
  label {
    padding: 10px 0;
    width: min-content;
    display: flex;
    align-items: center;
    font-size: 16px;
    line-height: 22px;
    gap: 10px;
    color: #555555;
    white-space: nowrap;
  }
  .radio {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 14px;
    height: 14px;
    padding: 2px;
    border-radius: 50px;
    background: #ffffff;
    border: 1px solid #cecece;
  }
  .ball {
    width: 8px;
    height: 8px;
    border-radius: 50px;
    background: #4dd2ae;
  }

  @media (max-width: 600px) {
    .buttonListWrap {
      gap: 4px;
      .itemButton {
        min-width: calc((100% - 16px) / 5);
        max-width: calc((100% - 16px) / 5);
        padding-top: 6px;
        padding-bottom: 4px;
        img {
          max-width: 90%;
          height: 60%;
        }
        p {
          font-size: 12px;
          line-height: 14px;
        }
      }
      .itemButton.active {
        /* padding-top: 6px;
        padding-bottom: 4px; */
        /* border: 3px solid #4dd2ae; */
      }
    }
    .selectWrap {
      gap: 6px;
    }
    .selectWrap.title {
      gap: 6px;
    }
    label {
      padding: 6px 0 30px 0;
    }
  }
`;
